import { IAdminEvent } from '../store';

import api, { request } from '../../../../api';
import { IStore } from '../../../';

export const editImage = async (state: IStore, clubId: number, event: IAdminEvent) => {
  const regex = /data:image\/([a-zA-Z]+);/;
  const found = event.image.match(regex);
  const extension = found ? found[1] : 'png';

  const filename = String((Math.random() * 10000000000000).toFixed()) + `.${extension}`;
  const formData = new FormData();

  const res = await fetch(event.image);
  const blob = await res.blob();

  formData.append('image', blob, filename);

  const response = await request.multipart(`${api.admin.events(clubId)}${event.id}/`, formData);

  if (response.error) {
    return { errors: { events: { msg: 'Error Creating the event.' } } };
  }

  const newEvent = {
    ...event,
    ...response
  };

  return {
    adminEvents: {
      all: {
        ...state.adminEvents.all,
        [response.id]: newEvent
      },
      current: newEvent,
      [response.id]: newEvent
    }
  };
};
